// When to show the gentle "support Tune Mondo" note: after 3 hours of actual
// listening, at most once every 30 days, and not for 6 months after someone
// opens a support link. Stored only on this device.
const HOUR=3600000,DAY=86400000;
export const NUDGE_AFTER_LISTENING=3*HOUR,NUDGE_EVERY=30*DAY,QUIET_AFTER_SUPPORT=180*DAY;
export const SUPPORT_STORAGE_KEY='tm:support';
export function normalizeNudge(value){
  const number=key=>Number.isFinite(Number(value?.[key]))?Number(value[key]):0;
  return {listenedMs:Math.max(0,number('listenedMs')),promptedAt:number('promptedAt'),supportedAt:number('supportedAt')};
}
export function nudgeDue(state,now=Date.now()){
  const s=normalizeNudge(state);
  return s.listenedMs>=NUDGE_AFTER_LISTENING&&(!s.promptedAt||now-s.promptedAt>=NUDGE_EVERY)&&(!s.supportedAt||now-s.supportedAt>=QUIET_AFTER_SUPPORT);
}
// Listening time only counts in short steps, so a sleeping tab or a stalled
// timer never adds hours at once.
export const addListening=(state,ms)=>({...normalizeNudge(state),listenedMs:normalizeNudge(state).listenedMs+Math.min(Math.max(0,ms),60000)});
// Showing the note restarts the listening count, so the next one needs 3 more hours.
export const markPrompted=(state,now=Date.now())=>({...normalizeNudge(state),promptedAt:now,listenedMs:0});
export const markSupported=(state,now=Date.now())=>({...normalizeNudge(state),supportedAt:now});
